import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import { PathLocationStrategy, LocationStrategy  } from '@angular/common';

//------------------directives---------------------
import {MatCardModule} from '@angular/material/card';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatFormFieldModule } from '@angular/material/form-field';
import {MatTabsModule} from '@angular/material/tabs';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatListModule} from '@angular/material/list';
import {MatSelectModule} from '@angular/material/select';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatInputModule} from '@angular/material/input';
// import {MatAccordion} from '@angular/material/expansion';
import {MatExpansionModule} from '@angular/material/expansion';
// For MDB Angular Free
import {  CarouselModule } from 'angular-bootstrap-md'
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { Ng2OdometerModule } from 'ng2-odometer';


//-------------------Components--------------------
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { CoursesComponent } from './courses/courses.component';
import { PlacementComponent } from './placement/placement.component';
// import { CareerComponent } from './career/career.component';
import { AboutComponent } from './about/about.component';
import { EventsComponent } from './events/events.component';
import { ContactComponent } from './contact/contact.component';
import { FooterComponent } from './footer/footer.component';
import { VerifyCertificateComponent } from './verify-certificate/verify-certificate.component';
import { EnquiryComponent } from './enquiry/enquiry.component';
import { SubmitEnquiryComponent } from './snackbars/submit-enquiry/submit-enquiry.component';
import { CertificateComponent } from './certificate/certificate.component';
import { CourseDetailComponent } from './courses/course-detail/course-detail.component';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { CookieConsentBannerComponent } from './cookie-consent-banner/cookie-consent-banner.component';
import { FaqSchemaComponent } from './Utils/faq-schema.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { TrustIndicatorsComponent } from './trust-indicators/trust-indicators.component';
import { UrgencyBannerComponent } from './urgency-banner/urgency-banner.component';
import { WhatsappFloatComponent } from './whatsapp-float/whatsapp-float.component';
import { ThankYouComponent } from './thank-you/thank-you.component';



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    CoursesComponent,
    PlacementComponent,
    // CareerComponent,
    AboutComponent,
    EventsComponent,
    ContactComponent,
    FooterComponent,
    VerifyCertificateComponent,
    CertificateComponent,
    EnquiryComponent,
    SubmitEnquiryComponent,
    CourseDetailComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    CookieConsentBannerComponent,
    FaqSchemaComponent,
    TestimonialsComponent,
    TrustIndicatorsComponent,
    UrgencyBannerComponent,
    WhatsappFloatComponent,
    ThankYouComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    MatCardModule,
    MatGridListModule,
    MatFormFieldModule,
    MatTabsModule,
    MatBottomSheetModule,
    MatListModule,
    MatSelectModule,
    MatSnackBarModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatTableModule,
    MatIconModule,
    // MatAccordion, 
    MatExpansionModule,
    CarouselModule,
    Ng2SearchPipeModule,
    Ng2OdometerModule.forRoot(),
    BrowserAnimationsModule
  ],
  entryComponents: [
    EnquiryComponent,
    SubmitEnquiryComponent
 ],
  providers: [{provide : LocationStrategy , useClass: PathLocationStrategy}],
  bootstrap: [AppComponent,HeaderComponent,FooterComponent]
})
export class AppModule { }
